module.exports = __webpack_public_path__ + "static/media/credit-card.bb2b69f5.svg";